import React from "react";
import "./ExampleBox.css";
import "./Layout.css";
import "./Homepage.css";

const ExampleBox = () => {
  return (
    <>
      <div className="arets-nisse-container">
        <div className="text-container" style={{ paddingBottom: "40px" }}>
          <a className="text-header">Årets tomtenisse</a>
          <p className="text-item arets-nisse">
            Årets tomtenisse är Knut! Han är inte en färdig tomtenisse än utan
            en nisselärling, men hans allra största dröm är att en dag få arbeta
            i tomtens verkstad. Vägen dit är dock lång. Det krävs mycket träning
            i både bus och tokigheter som hör nisselivet till. Därför har tomten
            skickat ut Knut till barnen. Här ska han få öva och ta reda på vad
            barn tycker är roligt med julen. Han vill så gärna lyckas, men
            eftersom han är nybörjare kan vi nog räkna med en del misstag och
            knasigheter på vägen.
          </p>
        </div>
        <img
          src={require("../media/images/aretsnisse.jpg")}
          alt="Nissedörr"
          className="door-image"
        ></img>
      </div>
      <div className="grey-container">
        <div className="text-container">
          <a className="text-header">Exempel</a>
          <p className="text-item">
            Här kan ni lyssna på en ljudfil från förra årets Nisseprat med
            nissen Greta.
            <br></br>
            Ni ser även ett utdrag från den tillhörande PDF-en.
          </p>
        </div>
        <div className="example-container">
          <audio controls className="example-object">
            <source src={require("../media/example.mp3")} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <img
            className="example-object"
            style={{ borderRadius: "20px" }}
            src={require("../media/images/exempel_uppdrag.png")}
            alt="Exempel på nisseuppdrag"
          ></img>
        </div>
      </div>
    </>
  );
};

export default ExampleBox;
